import React from 'react';
import { useSelector } from 'react-redux';

import { TabNames } from '../../../../../../../../../../constants/tabMenuTypes';
import RequirementTemplateBlueprintType from '../../../../../../../../../../types/RequirementTemplateBlueprintType';
import LoadingSpinner from '../../../../../../../../../Spinner';
import TrayHeader from '../../../../../../../../../Tray/TrayHeader';

import CreateCustomDocumentTypeForm from './CreateCustomDocumentTypeForm';

const CreateCustomDocumentTypeTray = ({ blueprint }) => {
  const activeStep = useSelector(blueprint.selectCreateCustomStep(TabNames.Documents));
  const currentEditCustomDocumentTypeId = useSelector(blueprint.selectCurrentEditCustomDocumentId);

  const titles = {
    0: currentEditCustomDocumentTypeId ? 'Edit Custom Document' : 'Create Custom Document',
    2: 'Edit Document Block'
  };

  const renderContent = () => {
    if (activeStep === 0 || activeStep === 2) return <CreateCustomDocumentTypeForm blueprint={blueprint} />;
    return <LoadingSpinner />;
  };

  return (
    <>
      <TrayHeader title={titles[activeStep]} />
      {renderContent()}
    </>
  );
};

CreateCustomDocumentTypeTray.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default CreateCustomDocumentTypeTray;
